import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import MetaData from "../layout/MetaData";
import AdminLayout from "../layout/AdminLayout";
import { useGetUserDetailsQuery, useUpdateUserMutation } from "../../redux/api/userApi";

const UpdateUser = () => {
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const params = useParams();

  const { data } = useGetUserDetailsQuery(params?.id);
  const [updateUser, { error, isSuccess }] = useUpdateUserMutation();

  useEffect(() => {
    if (data?.user) setRole(data?.user?.role);
  }, [data]);

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (isSuccess) {
      toast.success("User Updated");
      navigate("/admin/users");
    }
  }, [error, isSuccess]);

  const submitHandler = (e) => {
    e.preventDefault();
    updateUser({ id: params?.id, body: { role } });
  };

  return (
    <AdminLayout>
      <MetaData title="Update User" />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-10 col-lg-6">
            <div className="card p-4">
              <h2 className="mb-4 text-center">Update User Role</h2>

              <form onSubmit={submitHandler}>
                <div className="mb-4">
                  <label htmlFor="role_field" className="form-label">Role</label>
                  <select
                    id="role_field"
                    className="form-select"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option value="user">User</option>
                    <option value="driver">Driver</option>
                  </select>
                </div>

                <button type="submit" className="btn btn-primary w-100 py-2">
                  Update Role
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default UpdateUser;